import React, { Component } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { settings } from './settingsnew';
import { createGlobalStyle } from 'styled-components';
import AOS from 'aos';
AOS.init();


const GlobalStyles = createGlobalStyle`
    body.hide{
          overflow-y: hidden; /* Hide vertical scrollbar */
          overflow-x: hidden; /* Hide horizontal scrollbar */
        }
`;

class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );
  }
}

const Blog= function() {
    /* lightbox1 */
    const [lighbx, setlighbx] = React.useState(false);
    const handleBtnClick = (): void => {
      setlighbx(!lighbx);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "hidden";
    };
    const handleBtnClickclose = (): void => {
      setlighbx(!lighbx);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "auto";
    };
     /* lightbox2 */
     const [lighbx2, setlighbx2] = React.useState(false);
     const handleBtnClick2 = (): void => {
       setlighbx2(!lighbx2);
       var x = document.getElementsByTagName("BODY")[0];
       x.style.overflow = "hidden";
     };
     const handleBtnClickclose2 = (): void => {
       setlighbx2(!lighbx2);
       var x = document.getElementsByTagName("BODY")[0];
       x.style.overflow = "auto";
     }; 
     /* lightbox3 */
     const [lighbx3, setlighbx3] = React.useState(false);
     const handleBtnClick3= (): void => {
       setlighbx3(!lighbx3);
       var x = document.getElementsByTagName("BODY")[0];
       x.style.overflow = "hidden";
     };
     const handleBtnClickclose3 = (): void => {
       setlighbx3(!lighbx3);
       var x = document.getElementsByTagName("BODY")[0];
       x.style.overflow = "auto";
     };
      /* lightbox4 */
      const [lighbx4, setlighbx4] = React.useState(false);
      const handleBtnClick4= (): void => {
        setlighbx4(!lighbx4);
        var x = document.getElementsByTagName("BODY")[0];
        x.style.overflow = "hidden";
      };
      const handleBtnClickclose4 = (): void => {
        setlighbx4(!lighbx4);
        var x = document.getElementsByTagName("BODY")[0];
        x.style.overflow = "auto";
      };
	return(
		<div className="container">
            <GlobalStyles/>
            <div className="spacer-single"></div>
			<div className="row">
				<div className="col-md-12 text-center">
	                <h2>Recent Blog</h2>
	                <div className="space-border"></div>
	            </div>
			</div>
			<div className="row"
                data-aos="fade-up"
                data-aos-once="true"
                >
				<Slider {...settings}>
                <CustomSlide className='itm' index={1}>
                <div className="bloglist item">
                        <div className="post-content">
                            <div className="post-image">
                                <div className="de_modal" onClick={handleBtnClick}>
                                  <img alt="blogimg" src="./img/background/ui.png" className="grayscale"/>
                                </div>
                            </div>
                            <div className="post-text">
                                <h4 className="de_modal" onClick={handleBtnClick}>How to Make Better User Interface</h4>
                                <p>User Interface (UI) Design focuses on anticipating what users might need to do and ensuring that the interface has elements that are easy to access, understand, and use to facilitate those actions. UI brings together concepts from interaction design, visual design, and information architecture....</p>
                            </div>
                        </div>
                    </div>
                </CustomSlide>

                <CustomSlide className='itm' index={2}>
                <div className="bloglist item">
                        <div className="post-content">
                            <div className="post-image">
                                <div className="de_modal" onClick={handleBtnClick2}>
                                  <img alt="blogimg" src="./img/background/web_tip.jpg" className="grayscale"/>
                                </div>
                            </div>
                            <div className="post-text">
                                <h4 className="de_modal" onClick={handleBtnClick2}>10 Web Design Tips From Experts</h4>
                                <p> Why Website Designing is important?<br/>
It is easy to find website designing tips on the Internet. As a result...</p>
                            </div>
                        </div>
                    </div>
                </CustomSlide>

                <CustomSlide className='itm' index={3}>
                <div className="bloglist item">
                        <div className="post-content">
                            <div className="post-image">
                                <div className="de_modal" onClick={handleBtnClick3}>
                                  <img alt="blogimg" src="./img/background/flutter.jpg" className="grayscale"/>
                                </div>
                            </div>
                            <div className="post-text">
                                <h4 className="de_modal" onClick={handleBtnClick}>What is Flutter?</h4>
                                <p>Flutter is an open-source UI framework built by Google.Since 2017, Flutter has helped developers streamline their processes and achieve greater efficiency.This framework allows them to build both iOS and Android apps....</p>
                            </div>
                        </div>
                    </div>
                </CustomSlide>

                <CustomSlide className='itm' index={4}>
                <div className="bloglist item">
                        <div className="post-content">
                            <div className="post-image">
                                <div className="de_modal" onClick={handleBtnClick4}>
                                  <img alt="blogimg" src="./img/background/node.png" className="grayscale"/>
                                </div>
                            </div>
                            <div className="post-text" onClick={handleBtnClick}>
                                <h4 className="de_modal">Why use Node js for Backend Services</h4>
                                <p>Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...</p>
                            </div>
                        </div>
                    </div>
                </CustomSlide>

              </Slider>
			</div>

			  {/* lightbox1 */}
	          {lighbx && ( 
	          <div className="LightboxGal">
	            <div className="closeGal">
	                <button className="button-close" onClick={handleBtnClickclose}></button>
	            </div>
	            <div className="v-center w-100">
	              <div className="mainLightbox container">
	                <div className="row">
	                    <div className="col-md-8 offset-md-2">
                            <div className="blog-read">

                                <img alt="blogimg" src="./img/background/ui.png" className="img-fullwidth rounded"/>

                                <div className="post-info">
                                    <span className="post-date">April 1, 2018</span>
                                    <span className="post-like">181</span>
                                    <span className="post-comment">5</span>
                                </div>

                                <h2>How to Make Better User Interface</h2>

                                <div className="post-text">
                                    <p>User Interface (UI) Design focuses on anticipating what users might need to do and ensuring that the interface has elements that are easy to access, understand, and use to facilitate those actions. UI brings together concepts from interaction design, visual design, and information architecture.

Choosing Interface Elements
Users have become familiar with interface elements acting in a certain way, so try to be consistent and predictable in your choices and their layout. Doing so will help with task completion, efficiency, and satisfaction.

Interface elements include but are not limited to:

Input Controls: buttons, text fields, checkboxes, radio buttons, dropdown lists, list boxes, toggles, date field
Navigational Components: breadcrumb, slider, search field, pagination, slider, tags, icons
Informational Components: tooltips, icons, progress bar, notifications, message boxes, modal windows
Containers: accordion
There are times when multiple elements might be appropriate for displaying content.  When this happens, it’s important to consider the trade-offs.  For example, sometimes elements that can help save you space, put more of a burden on the user mentally by forcing them to guess what is within the dropdown or what the element might be. 

Best Practices for Designing an Interface
Everything stems from knowing your users, including understanding their goals, skills, preferences, and tendencies.  Once you know about your user, make sure to consider the following when designing your interface:

Keep the interface simple. The best interfaces are almost invisible to the user. They avoid unnecessary elements and are clear in the language they use on labels and in messaging.
Create consistency and use common UI elements. By using common elements in your UI, users feel more comfortable and are able to get things done more quickly.  It is also important to create patterns in language, layout and design throughout the site to help facilitate efficiency. Once a user learns how to do something, they should be able to transfer that skill to other parts of the site. 
Be purposeful in page layout.  Consider the spatial relationships between items on the page and structure the page based on importance. Careful placement of items can help draw attention to the most important pieces of information and can aid scanning and readability.
Strategically use color and texture. You can direct attention toward or redirect attention away from items using color, light, contrast, and texture to your advantage.
Use typography to create hierarchy and clarity. Carefully consider how you use typeface. Different sizes, fonts, and arrangement of the text to help increase scanability, legibility and readability.
Make sure that the system communicates what’s happening.  Always inform your users of location, actions, changes in state, or errors. The use of various UI elements to communicate status and, if necessary, next steps can reduce frustration for your user. 
Think about the defaults. By carefully thinking about and anticipating the goals people bring to your site, you can create defaults that reduce the burden on the user.  This becomes particularly important when it comes to form design where you might have an opportunity to have some fields pre-chosen or filled out..</p>
                                </div>

                            </div>

                            <div id="blog-comment">
                                <h4>Comments</h4>

                                <div className="spacer-half"></div>

                                <ol>
                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-1.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Jovan Eadie</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>

                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-2.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Ariana Haylock</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>

                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-3.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Reginald Safi</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>
                                </ol>

                                <div className="spacer-single"></div>

                                <div id="comment-form-wrapper">
                                    <h4>Leave a Comment</h4>
                                    <div className="comment_form_holder">
                                        <form id="contact_form" name="form1" className="form-border" method="post" action="#">
                                            <label>Name</label>
                                            <input type="text" name="name" id="name" className="form-control"/>
                                            <label>Email <span className="req">*</span></label>
                                            <input type="text" name="email" id="email" className="form-control"/>
                                            <label>Message <span className="req">*</span></label>
                                            <textarea cols="10" rows="10" name="message" id="message" className="form-control">
                                            </textarea>
                                            <p id="btnsubmit">
                                            <input type="submit" id="send" value="Send" className="btn btn-main"/>
                                            </p>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
	                </div>
	              </div>
	            </div>
	          </div>
	          )}
              
			  {/* lightbox2 */}
	          {lighbx2 && ( 
	          <div className="LightboxGal">
	            <div className="closeGal">
	                <button className="button-close" onClick={handleBtnClickclose2}></button>
	            </div>
	            <div className="v-center w-100">
	              <div className="mainLightbox container">
	                <div className="row">
	                    <div className="col-md-8 offset-md-2">
                            <div className="blog-read">

                                <img alt="blogimg" src="./img/background/web_tip.jpg" className="img-fullwidth rounded"/>

                                <div className="post-info">
                                    <span className="post-date">April 1, 2018</span>
                                    <span className="post-like">181</span>
                                    <span className="post-comment">5</span>
                                </div>

                                <h2>10 Web Design Tips From Experts</h2>

                                <div className="post-text">
                                    <p>
                                    Why Website Designing is important?<br/>
It is easy to find website designing tips on the Internet. As a result, many people have different ideas about what the ideal website should look like. Design, to a certain degree, is subjective. The taste of one person may be disgusting to another. 
To be sure, web design is an important factor in determining a website’s overall success. It’s no surprise that nearly half of people say that the design of a site is the most important factor in determining the legitimacy of a company. Additionally, it has an impact on conversion rates, bounce rates and more. 
How to do web designing:<br/>
There’s no way to get objective data on how successful web design is done. But wait, there’s more! It’s all in this article. Keep reading for some science-backed website designing tips. Avoid following your gut instinct and start implementing strategies that have been proven to work. 
Businesses of all sizes, including brick-and-mortar stores that do not engage in online commerce, require an online presence in today’s world. With the many website creation tools available, creating a website isn’t that difficult. Regardless of the software you choose, keep these principles in mind when creating it. 
10 Highly Effective Website designing tips:<br/><br/>
1. Avoid hectic color schemes<br/>
With so many wonderful shades and hues out there, it’s easy to go overboard with color. Though bright and bold color schemes are at the cornerstone of many designers’ aesthetics, when you put too many colors too close together, the visual noise that is created overpowers the rest of the web design.

Stick with a simple color palette and neutral background colors. A toned-down background makes instances of color — such as colors on call-to-action buttons, menu items, or other design elements — stand out and get the attention they deserve. Sometimes all you need is a simple white, black, or neutral background.
Made in Webflow, this website for the hairstylist Emi Styles is a great example of how a simple color scheme can project a sense of calm and order. To better understand how to best use color in your own web design, read up on color theory to help you make better decisions about your own color schemes.
<br/><br/>
2. Put some thought into the images you include<br/>
The photos that are integrated into a web design layout have a huge impact on the overall look and feel of a website. Poorly shot images with fuzzy focus and questionable composition can diminish even the most brilliant of designs. Generic stock photos can drain the life from a design, leaving it bland and uninspiring.

Using high-quality photos is a simple way to improve your designs.

There are plenty of great options out there if you want to use stock photos. But don’t just plop them down into your designs as they are. Make sure you crop and edit them. Use filters, adjust the saturation, change the warmth, bump up the contrast, and use other photo editing techniques to make the images better fit in with the harmony of a web design.

Additionally, make sure that whatever images you choose fit within the context of the content they’re appearing with. If a photo doesn’t relate at all to the section it’s being placed into, you may need to find one that fits the content better.

Lastly, pay attention to the file types you’re using. Know the difference between a JPG and a PNG. Implementing the correct file types can make a huge difference in how fast your pages load.
<br/><br/>
3. Learn about SEO<br/>
We know you didn’t devote yourself to the art of web design to be bothered by search engine optimization. But how you put together a web design can have a great impact on SEO.

As a web designer, a few things you should know about search engine optimization include:<br/>

How to properly use header tags like 
How the part of a link that identifies a specific page — aka a slug — can influence organic search rankings
How to optimize images to speed up loading times and decrease the bounce rate — which is the percentage of visitors who only view one page on your site and then navigate away without taking any actions
Of course, we can’t distill the complexities of SEO into three bullet points. If you’d like a helpful introduction to search engine optimization, please check out our blog post “9 SEO best practices for your Webflow website.”
<br/><br/>
4. Use responsive design<br/>
There are many devices out there with varying screen sizes. No matter how someone is accessing your web design, it should offer a similar experience no matter what it’s being viewed on. Instead of putting a huge amount of effort into overly complex animations and hover effects that may not work on every device, it’s better to spend that time improving UI and UX for everyone.

Following the tenets of responsive design means your website will be user-friendly and offer an optimized experience across desktop and mobile devices.

To learn more, check out our course material “Intro to Responsive Design” to help you understand how to make your own designs more accessible.
<br/><br/>
5. Keep typography consistent<br/>
When we sit down to read a book, we expect that every page will follow a sense of order. The text will be the same size, set with exact spacing, and follow the same repeating format. This sense of congruity keeps us engaged, offering an uninterrupted experience in reading through a book’s pages.

Similarly, the typography in a web design also needs to have a sense of order and consistency. Headers, body text, links, and other text need to follow the same styling from one page of a website to the next. Additionally, padding, line spacing, size, color, and weight should be identical for a given type of content.

We’re fans of setting up a universal style guide page for each website you create. By doing so, you can make sure typography is consistent across a web design.

For reference, Webflow’s style manager is a handy tool in managing text styles like headers and body copy — making it easy to keep track of all the text styles you have in place.
<br/><br/>
6. Keep diversity and inclusion in mind<br/>
People landing on a home page come from a variety of backgrounds, ethnicities, genders, abilities, and ages. Being a good web designer means creating a welcoming user experience for everyone. When choosing photography and character illustrations, make sure they represent people from different walks of life.
We’ve sung the praises for Pablo Stanley’s free character illustration generator Humaaans in the past. It’s a simple way to fill your design with a wide range of people.
<br/><br/>
7. Define who you are as a designer<br/>
It’s not uncommon for designers to have multifaceted skill sets that include UI, UX, and other aspects of web creation. A web designer rarely has a singular focus when working on projects.

However, because there are so many different aspects to design, it’s an impossible undertaking to be adept at everything. It’s important for designers to pursue aspects of design that are personally exciting and interesting to them. Good designers know that having specialties, and becoming experts in those specialties, helps set their work apart and makes them more attractive to potential clients.

Though many designers find themselves bouncing from one type of project to another early in their careers, with progress, growth, and introspection, finding a niche becomes easier.

To start, figure out what type of businesses or clients make you the happiest to work with. If you’re into all things tech, you might want to seek out SaaS companies, startups, and others in the digital sphere. If you’re a foodie, you might find designing restaurant websites a perfect fit for your culinary appreciation.

Defining yourself as a designer also extends to your own artistic aesthetic. Whether you enjoy precision-crafted minimalist designs or like pushing the boundaries with abstract and conceptual design, make sure to have a design voice that’s uniquely your own.

Knowing who you are as a designer makes it easier to find the projects you want to work on and the people you want to work with. It also enables you to have a focused LinkedIn profile and portfolio, letting potential clients recognize your talents right away.
<br/><br/>
8. Mentor a designer<br/>
Becoming a mentor isn’t only a way to give back and help out an aspiring designer — it can also make it easier to better critique your own designs.

Being a mentor is more than just giving website design tips. It means being able to analyze a problem someone may be having and explaining why it’s not working, as well as the steps they can take to improve it. Paying attention to someone else’s work and exercising the analytical part of your brain will make it easier for you to evaluate your own designs.
<br/><br/>
9. Write case studies<br/>
Case studies should be a part of any web designer’s portfolio website, but so many skip over creating them. While they do take a bit of time and effort, case studies can help you out in multiple ways.

Case studies add so much to a portfolio. Website visitors get an in-depth look at your process, see how you approach problem-solving, and develop a better understanding of who you are as a designer.

Taking a granular look at your work as a web designer also helps you better understand what you’re doing right and identify areas where you may need to improve. Case studies exist as a detailed archive of your work and are a great record of your progress.
<br/><br/>
10. Understand the principles of web design<br/>
The intuition that guides the decision-making of skilled designers comes from knowing the principles of design.

Take the time to learn about the fundamentals of UI, UX, typography, composition, and color theory. Understand visual hierarchy, the rudiments of Gestalt theory, and the golden ratio. Dive into the more cerebral aspects of design so you can put these lessons into practice on your own work.

If you want a great place to begin your learning, check out this post we did about 10 effective web design principles every designer should know.
                                        
                                    </p>
                                </div>

                            </div>

                            <div id="blog-comment">
                                <h4>Comments</h4>

                                <div className="spacer-half"></div>

                                <ol>
                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-1.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Jovan Eadie</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>

                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-2.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Ariana Haylock</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>

                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-3.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Reginald Safi</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>
                                </ol>

                                <div className="spacer-single"></div>

                                <div id="comment-form-wrapper">
                                    <h4>Leave a Comment</h4>
                                    <div className="comment_form_holder">
                                        <form id="contact_form" name="form1" className="form-border" method="post" action="#">
                                            <label>Name</label>
                                            <input type="text" name="name" id="name" className="form-control"/>
                                            <label>Email <span className="req">*</span></label>
                                            <input type="text" name="email" id="email" className="form-control"/>
                                            <label>Message <span className="req">*</span></label>
                                            <textarea cols="10" rows="10" name="message" id="message" className="form-control">
                                            </textarea>
                                            <p id="btnsubmit">
                                            <input type="submit" id="send" value="Send" className="btn btn-main"/>
                                            </p>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
	                </div>
	              </div>
	            </div>
	          </div>
	          )}

               {/* lightbox1 */}
	          {lighbx3 && ( 
	          <div className="LightboxGal">
	            <div className="closeGal">
	                <button className="button-close" onClick={handleBtnClickclose3}></button>
	            </div>
	            <div className="v-center w-100">
	              <div className="mainLightbox container">
	                <div className="row">
	                    <div className="col-md-8 offset-md-2">
                            <div className="blog-read">

                                <img alt="blogimg" src="./img/background/flutter.jpg" className="img-fullwidth rounded"/>

                                <div className="post-info">
                                    <span className="post-date">April 1, 2018</span>
                                    <span className="post-like">181</span>
                                    <span className="post-comment">5</span>
                                </div>

                                <h2>What is Flutter?</h2>

                                <div className="post-text">
                                    <p>
                                    What is Flutter?<br/>
Flutter is an open-source UI framework built by Google. It helps developers create native mobile and multi-platform apps from a single codebase. Since 2017, Flutter has helped developers streamline their processes and achieve greater efficiency. This framework allows them to build both iOS and Android apps from a single code base with one programming language.
<br/>
This Google-built framework consists of these components:<br/>
Software Development Kit (SDK)<br/>
A SDK is a collection of tools that help developers build their applications. It allows them to compile their code into native machine code used on both iOS and Android.
<br/><br/>
Widget-based UI Library<br/>
This framework has various UI elements that can be reused, including sliders, buttons, and text inputs.

The programming language of Flutter is Dart, which was created by Google in 2011. Dart is a typed object programming language that focuses on front-end development, like JavaScript.
<br/>
What Kind of Apps You Can Develop<br/>
Flutter is a good choice if you want to develop 2D cross-platform apps that you want to make available on both iOS and Android mobile devices. It’s also a good choice for building desktop- and web-based interactive apps. 
<br/><br/>
Generally, you can build any type of cross-platform app using Flutter. Many different companies worldwide are already using it, including Alibaba, Yandex, Airbnb, and Uber. That said, you can use Flutter to create apps for:
Retail
Many retail apps have the same set of basic functions such as product comparison, catalog, finding the nearest stores, promotions, and so on. Since the same features and look is required for both iOS and Android, it would be wasteful to build separate apps.
<br/>
Fintech<br/><br/>
Since the banking sector needs to pay special attention to security, it has to follow the most recent tech trends . Many companies from the banking sector choose Flutter for their apps, compared to native ones, since it’s much safer. Native apps can be reverse engineered to restore their original code. Apps built with Flutter cannot be reverse engineered. Flutter-based apps can use security technologies such as Touch ID, Face ID, or a fingerprint scanner. One of the biggest digital banks, Nubank, is the best case of how the banking sector can integrate Flutter into a mobile app.
<br/>
Suppliers and Franchisees<br/><br/>
Since the budget for the internal apps is lower than client apps, many companies choose to build their internal apps through Flutter. Flutter provides a ready-made environment as opposed to doing everything from scratch.
<br/>
Large Businesses <br/><br/>
Businesses with call centers, courier control, and complex internal processes can benefit from Flutter apps due to the advantages listed below.
<br/>
What Types of Apps is Flutter Not Suitable For?<br/>
When it comes to video apps, Flutter experiences significant limitations. For this reason, Flutter is not suitable for apps that need UI rendering. 
<br/>
Furthermore, Flutter isn’t the best solution for apps that closely integrate with their underlying hardware. Those apps, such as mobile stock exchange apps, need deep performance optimization. 
<br/>
If you are building an augmented reality (AR) app, you may want to avoid Flutter. AR requires deep integration with native platforms, so building a cross-platform app would not be useful. Some examples include auto businesses, furniture stores, or interior salons where users need to see products in 3D.
<br/>
Popular Apps Built on Flutter<br/>
Here are some examples of well-known apps that have been built using Flutter.
<br/><br/>
Google Ads: Apps built with Flutter allow marketers to manage Google ad campaigns directly from their smartphones.
Alibaba: This is one of the biggest eCommerce platforms in the world that chose Flutter as their preferred cross-platform solution.
Google Pay: Being Google’s product, it’s no surprise that this app is built with Flutter. Given that payment apps need to be secure, responsive, and bug-free, we see this as the greatest Flutter endorsement.
Grab: A popular food delivery app built with Flutter that helps local businesses add menu items, manage orders, and view earnings.
Realtor.com: A real-estate app that helps people find their dream homes and it’s built with the help of Flutter.
Why Use Flutter to Build Your Applications?<br/><br/>
Top 11 Advantages of Flutter and its Features<br/><br/>
1. Improved Productivity<br/>
Flutter allows developers to use the same code to create both iOS and Android apps. In doing so, they save time and resources since they don’t have to build two separate apps. Flutter’s native widgets also reduce time spent on testing by ensuring compatibility with different operating systems.
<br/><br/>
2. Easy to Learn<br/>
Flutter developers can create mobile apps without using OEM widgets or a lot of code, making their process much easier and simpler.
<br/><br/>
3. Better Performance<br/>
Many users say it’s nearly impossible to tell the difference between a Flutter app and a native mobile app - a big upside for developers.
<br/><br/>
4. Lower Costs<br/>
By allowing developers to build apps both for Android and iOS from the same code base, Flutter slashes the coding time by at least half. This means the costs of app development are also reduced. You basically get two apps for the cost of one.
<br/><br/>
5. Robust Documentation and Strong Community<br/>
One reason many companies choose Flutter is the robust documentation and resources that helps developers solve problems. Furthermore, Flutter has great community hubs such as Flutter Community and Flutter Awesome where developers can exchange ideas and solve problems.
<br/><br/>
6. Improved Time-to-Market Speed<br/>
Generally, Flutter development only requires up to half the time needed to build the same app separately for Android and for iOS. Developers don’t have to write any platform-specific code to achieve the desired visuals in their application. Plus, Flutter provides a declarative API for building user interfaces, helping boost performance.
<br/><br/>
7. Allows Customization<br/>
One of the main benefits of using Flutter is the ability to customize anything you see on the screen, regardless of its complexity. Although native platforms also allow customization, it’s usually much harder to achieve the same thing.
<br/><br/>
8. App Usage Beyond Mobile<br/>
Flutter allows developers to go further than mobile app development. There is also Flutter for Web and Flutter Desktop Embeddings, both of which allow developers to run Flutter applications in a browser without modifying any source code. While the non-mobile parts of the framework aren’t yet production-ready, an experienced Flutter developer can make a Flutter app run on web browsers, Windows, macOS, and Linux. 
<br/><br/>
9. Flutter Has its Own Rendering Engine<br/>
Companies using Material Design for Android and Human Interface for iOS can benefit from Flutter. The Flutter framework provides packages that contain custom widgets used for both iOS and Android.
<br/><br/>
10. Hot Reload Feature<br/>
Flutter’s hot reload is a great feature that allows developers to save hours’ worth of time. Hot reload lets developers make changes to the code and watch them take effect in real-time while avoiding rebooting the entire app. 
<br/><br/>
11. Pixel Rendering Feature<br/>
Flutter manages every pixel of the screen. This ensures that widgets look the same on every mobile device, removing potential device support woes. This enables developers to create user interfaces that look exactly the same on both Android and iOS using a single codebase.
<br/>
Drawbacks of Using Flutter<br/>
Now that we’ve seen the benefits of Flutter app development, let’s go over some of its drawbacks:
<br/><br/>
1. Finding Flutter Developers Remains Challenging<br/>
While Flutter may be seamless, difficulty arises from finding developers experienced with Flutter. The labor market for this technology is just starting to grow, and for now, most developers seeking jobs are still new to Flutter.
<br/><br/>
2. Large File Sizes<br/>
One of the main tasks of app developers is to create an app that doesn’t consume too much space on the user’s phone. To do so, developers avoid using animations, reduce image sizes, or use a minimum of packages and libraries. Flutter here shows poor results, and their apps generally tend to take too much space.
<br/><br/>
3. Insufficient iOS Support<br/>
Since Flutter is Google’s product, the support for iOS is much worse compared to one for Android. That said, it can happen that most of the SDK functions that work properly on Android show problems with iOS.
<br/><br/>
4. Lacks Password Management Support<br/>
If you want to use your own features instead of native widgets, you’ll likely experience some problems. For instance, Flutter applications sometimes struggle with autocomplete input fields. There may be hiccups when extracting passwords from built-in or third-party password managers.


                                    </p>
                                </div>

                            </div>

                            <div id="blog-comment">
                                <h4>Comments</h4>

                                <div className="spacer-half"></div>

                                <ol>
                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-1.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Jovan Eadie</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>

                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-2.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Ariana Haylock</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>

                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-3.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Reginald Safi</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>
                                </ol>

                                <div className="spacer-single"></div>

                                <div id="comment-form-wrapper">
                                    <h4>Leave a Comment</h4>
                                    <div className="comment_form_holder">
                                        <form id="contact_form" name="form1" className="form-border" method="post" action="#">
                                            <label>Name</label>
                                            <input type="text" name="name" id="name" className="form-control"/>
                                            <label>Email <span className="req">*</span></label>
                                            <input type="text" name="email" id="email" className="form-control"/>
                                            <label>Message <span className="req">*</span></label>
                                            <textarea cols="10" rows="10" name="message" id="message" className="form-control">
                                            </textarea>
                                            <p id="btnsubmit">
                                            <input type="submit" id="send" value="Send" className="btn btn-main"/>
                                            </p>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
	                </div>
	              </div>
	            </div>
	          </div>
	          )}

                {/* lightbox */}
	          {lighbx4 && ( 
	          <div className="LightboxGal">
	            <div className="closeGal">
	                <button className="button-close" onClick={handleBtnClickclose4}></button>
	            </div>
	            <div className="v-center w-100">
	              <div className="mainLightbox container">
	                <div className="row">
	                    <div className="col-md-8 offset-md-2">
                            <div className="blog-read">

                                <img alt="blogimg" src="./img/background/node.png" className="img-fullwidth rounded"/>

                                <div className="post-info">
                                    <span className="post-date">April 1, 2018</span>
                                    <span className="post-like">181</span>
                                    <span className="post-comment">5</span>
                                </div>

                                <h2>When, How, And Why Use Node.js as Your Backend? [2022 Update]</h2>

                                <div className="post-text">
                                    <p><br/>
Choosing backend technology is one of the most important decisions that every CEO and CTO has to make. It determines how fast a product can be shipped to market, what the total cost will amount to, and how intensive maintenance is likely to be.
<br/>
Historically, JavaScript has been one of the most popular client-side programming languages and frontend web development tools. However, it never provided a backend platform that could outmatch its competitors.
<br/>
But, in recent years, JavaScript has begun to gain ground in different areas of application and on distinct platforms, such as React Native, Appcelerator Titanium, Apache Cordova/ PhoneGap, NativeScript, and Node.js. Node.js is the first viable alternative that appeals to those looking to unify their programming language.
<br/>
Node.js remains totally different from other commonly used JavaScript frameworks, as it is the first environment to support JavaScript on both the client- and server-side, and therefore comes with its own unique range of advantages and drawbacks.
<br/><br/>
What is Node.js, and why is it used?<br/>
Get a full picture of Node.js using this helpful guide to avoid making serious development mistakes that could cost you valuable time and money.
<br/><br/>
Is Node.js used for frontend or backend?<br/>
Node.js is not technically a framework in the traditional sense, nor is it a programming language or a library; but, instead, it is a Google V8 JavaScript runtime environment that allows you to execute JavaScript code on the server-side, either frontend or backend.
<br/><br/>
Even though it was originally written back in 2009 by Ryan Dahl, it wasn’t widely adopted until recently, instead gradually being adopted as an enterprise-level tool over time.
<br/>
Currently, numerous thriving companies have leveraged Node.js technologies in developing their applications, including Walmart, Netflix, Medium, Uber, LinkedIn, Groupon, and even NASA.
What is the purpose of Node.js?<br/><br/>
The creator of Node.js, Ryan Dahl, was inspired by Gmail to create functionality for real-time websites to have push capability. He wanted to build a tool for developers that was non-blocking and event-driven, revolutionising the real-time possibilities.
<br/>
To summarise the functionality of Node.js, its main benefit is that it offers speed: speed of data processing and client-server interaction, speed of development, and speed of progression. As a result, Node.js offers event-driven two-way connections between client and server, where both sides of the equation can initiate communication and exchange data.
<br/>
Node.js excels at the sort of scalable and real-time situations that we are increasingly asking of our web servers, thanks to its unique I/O model.
<br/>
In this way, it fills a very specific gap in the market. While other techniques will spawn a new thread for every request that’s made, Node.js runs on one single-threaded event loop using non-blocking I/O calls, saving RAM and still supporting thousands of simultaneous connections.
<br/>
More traditional web-serving methods require a new thread for each new connection, which weighs heavily on a system’s RAM; but, with just one thread, Node.js keeps things running smoothly, provided the requests aren’t too intensive.
<br/>
In addition, Node.js is also lightweight, efficient, and its ability to use JavaScript code on both frontend and backend opens new avenues for development. The front- and backend flexibility makes your development team far more efficient and cross-functional, and therefore lowers development costs.
<br/>
With Node.js, code can be reused and shared in both the front- and backend parts of your application to speed up development. It is worth noting here that JavaScript is the most popular programming language, thanks to the single-thread event loop that facilitates asynchronous programming, so your application’s codebase will be easier to understand for any additional engineers.
<br/>
How is Node.js different from web JavaScript?<br/><br/>
There is no explicit difference between the JavaScript used in web browsers and the JavaScript used in Node.js. But, what makes Node.js special is the different set of APIs that it uses. In browsers, you have a variety of DOM/Web APIs exposed that help you interact with the User Interface (UI) and allow you to access the hardware to a limited extent.
<br/>
With Node.js, however, the APIs are suitable for backend development, including support for file systems, http requests, streams, and child processes, giving you better access and increased speed and functionality. Browsers do offer some basic support for file systems or HTTP requests, but those are usually limited due to security concerns.
<br/>
Node js vs Javascript<br/>
Pros of using Node.js for backend development<br/><br/>
Knowing all the ways in which Node.js could benefit your application development is essential to understanding which projects it might be most suitable for and employing it in the most valuable way. Here are the key features of Node.js that you can take advantage of.
<br/>
Using Node.js as your server technology gives your team a great boost that comes from using the same language on both the front end and back end. This means that your team is more efficient, which, in turn, leads to lower development costs.
<br/><br/>
Cross-Functional Teams<br/>
According to Node.js’s 2018 User Survey, JavaScript is one of the most popular programming languages for frontend development. In StackOverflow’s 2021 developer survey, Node.js took the 6th spot:
<br/><br/>
Nearly every frontend developer is familiar with this universal language. Therefore, it is much easier for them to switch to using Node.js at the backend, too.
<br/><br/>
In turn, less effort and time is put into training and re-training, and Node.js can be picked up by even a junior JavaScript programmer (Node.js can be picked up in a matter of weeks by a developer with JavaScript skills).
<br/>
In a cross-functional team like this, you will have a whole range of experts able to work seamlessly together, and every member shares the responsibility for writing the initial code, testing it, deploying updates, and maintaining function. Altogether, this results in a more agile, more innovative team.
<br/>
Freedom in Building Apps (Especially Cross-Platform)<br/><br/>
While Ruby on Rails is a popular framework with a set of rules and guidelines for developing software in a particular way, Node.js gives you much more space and freedom to do things your own way. Node.js is completely unopinionated, so you can start everything from scratch, creating applications that work across Windows, macOS, and Linux, without having to develop on that specific operating system.
<br/>
Your developers can easily work on web and desktop apps together, without having expert knowledge of additional programming languages. In addition, backend developers can make use of tools such as the Google Chrome Developer Tools.
<br/>
From a fresh install, Node.js can execute basic tasks, but by starting with the bare minimum your developers are less restricted and programming can remain uncluttered and streamlined.
<br/><br/>
Full Stack JavaScript<br/>
Before Node.js, JavaScript was only used for client-side development. You had to hire a separate team for backend and for frontend development. With the growing popularity of Node.js, full stack development in JavaScript became a reality. Now, it is possible to write both the frontend and backend of web applications in JavaScript, making Node app deployment much easier and more efficient.
<br/><br/>
Scalability<br/>
One of the chief benefits of Node.js is how easily scalable the environment is. Your system is both lightweight and fast from the get-go, with the potential to add additional modules easily at a later date.
<br/>
It facilitates the building of applications that can grow as your business does, thanks to the simplicity of its single-thread event loop and its ability to handle so many concurrent connections.
<br/>
As processes become more complex, an application built with Node.js can be scaled vertically and horizontally, and Cluster modules can help you balance loads across multiple CPUs.<br/>
Moonfare – powered by Node.js. AWS offers plenty of tools that have great support for Node.js. Moonfare has taken advantage of the AWS-Node.js combination and is now able to easily handle any number of requests and pay according to their actual usage.<br/>
<br/>
Active Community<br/>
<br/>The Node.js developers’ community is a very active and vibrant group of developers who contribute to the constant improvement of Node.js. Members are willing to go the extra mile to provide their fellow software developers with reliable software solutions.
<br/>
Plus, with the input of JavaScript programmers, you get access to countless ready solutions, codes in GitHub, and much more. As a result, the number of StackOverflow questions is also steadily increasing, further adding to the knowledge base that surrounds the technology.
<br/><br/>
Node Package Manager<br/>
Similar to Ruby Gems, the Node Package Manager (NPM) provides users with a set of components that are readily and publicly available for use to help solve common and/or niche issues and provide an enhanced Node.js user experience. To date, the number of modules available, created by third-party developers, exceeds one million.
<br/>
The NPM CLI tool is automatically installed with Node.js, making this repository easily accessible for users. If you find a particularly valuable solution to a problem you’ve experienced, you can share your own module on the NPM too.
<br/>
For big organisations looking for added security, the NPM has released an Enterprise version that can be run behind your company’s firewall and gives you access to a private registry with advanced security features that can detect vulnerabilities and unsafe code.

YARN<br/>
A popular alternative to the NPM is YARN (Yet Another Resource Negotiator), which was originally developed by Facebook to fix initial security and performance issues with NPM (which have now been resolved) but has since become open-source.
<br/>
As well as an effective package manager, YARN also works as a project manager, helping ensure that any third-party solutions you download stay up-to-date and supported throughout their use lifetime.
<br/>
With YARN, you can utilise the solutions that other Node.js developers have put together, while also sharing your own solutions and contributing to the community.
<br/>
Unlike the NPM, YARN is not tied to a specific business or company, so it runs entirely on the support of its members and contributors. Most of the commands used in YARN remain the same as in NPM, so transitioning your developers from one to another should be fairly simple; however, many developers prefer the clean, simple output logs of YARN over the more complex logs of NPM.
<br/>
Simultaneous Request Handling<br/>
Node.js provides a non-blocking IO system that lets you process numerous requests concurrently.
<br/>
The system’s ability to handle simultaneous connections is much better than with Python or Ruby. Node.js can process many requests with low response times at once and share validation codes between client and web server, making it a great fit for modern web applications that carry out lots of processing on the client’s side.
<br/>
Incoming requests are queued up and executed sequentially in a fast manner, so your app will use less system RAM, scale easily, and perform faster.
<br/>
It’s important to note, however, that Node.js isn’t this efficient when a lot of CPU processing is involved, as large calculations would clog up the thread.
<br/>
Now, workarounds such as Node.js Worker Threads (introduced in Node.js v10.5.0) can assist with this. For this reason, Node.js continues to be popular among single-page application sites, where all rendering occurs on the client’s side and the backend only provides a JSON API.
<br/>
If you are primarily shuffling data around, then Node.js will be quite efficient, because a single instance can serve a lot more requests with the same hardware, compared to the usual “thick” application server (as is the case with Rails).
<br/><br/>
Microservice Architectures<br/>
Often in the process of developing a new application, it will become clear that one part of the application is working more efficiently than another, and this second part will need to be scaled quickly.
<br/>
By using the microservice architecture possible with Node.js, you can divide your app up into its individual capabilities, hand off each microservice to a different team, and develop each section as is required without jeopardising the other components.
<br/>
These teams can therefore also be delocalised, which facilitates hiring exactly the right team of experts you need, and only the necessary updates are deployed every time you update, rather than starting a full reboot.
<br/><br/>
Suitable for RTAs<br/>
As Node.js is a good choice for applications that have to process a high volume of short messages requiring low latency, it proves popular with those developing real-time applications (RTAs) and applications that utilise artificial intelligence.
<br/>
Node.js facilitates handling multiple client requests, enables sharing and reusing packages of library code, and quickly syncs client and server data.
<br/>
For this reason, it’s well-suited to developing real-time collaborative drawing or editing apps, where users can watch the document being edited by someone else live (for example, Trello, Dropbox Paper, and Google Docs), as well as live-chat and instant-messaging apps.
<br/><br/>
Cons of using Node.js for backend development<br/>
If we only look at the advantages of Node.js, then using it for your own application development seems like a no-brainer.
<br/>
In reality, there are instances in which Node.js would prove unsuitable for, and/or detrimental to, the project. To make sure it’s the right option for you, take a look at the disadvantages listed here, too.
<br/><br/>
Unstable API<br/>
One of the biggest disadvantages of Node.js is that it lacks consistency. Node.js’ API changes frequently, and the changes are often backwards-incompatible. When this happens, programmers are forced to make changes to the existing code base to make it compatible with the latest version.
<br/><br/>
More development time<br/>
The unopinionated nature of Node.js can be seen as a drawback. From a fresh install, Ruby on Rails provides you with a lot of direction and guides you through their way of doing things.
<br/>
With Node.js, you need to write everything from scratch. Worst case scenario, this results in a decrease in productivity. However, cooperating with an experienced programming team that has adopted good processes for developing and maintaining code, can negate this risk to efficiency.
<br/>
Not Suitable for heavy-computing apps<br/>
As we touched on above, Node.js doesn’t yet support multi-threaded programming. It is capable of serving far more complicated applications than Ruby, but it’s not suitable for performing long-running calculations. Heavy computations block the incoming requests, rendering the biggest advantage of Node.js useless.
<br/>
While Node.js is perfect for lightweight yet complex apps, in the case of software that requires some heavy computing, it might perform less effectively than traditional methods. Modules such as ‘forever’ can be added to your Node.js framework from the NPM to help prevent particularly damaging crashes, if an exception finds its way onto the single thread.
<br/><br/>
System crashing<br/>
In the instance of an exception finding its way into the core of the event loop, the entire programme may crash, without the prospect of being able to recover the state of the user session before the crash. External systems can be used to tackle this issue, or, as mentioned above, modules like ‘forever’ can be used to set up callback parameters that will pass the error back to the caller.
<br/><br/>
Immaturity of tools<br/>
Even though the core Node.js is stable, many packages in the NPM registry are still of poor quality or have not been properly documented. As it is mostly an open-source ecosystem, numerous tools have not been supervised, and so they might fail to meet coding standards.
<br/>
The NPM’s structure makes it harder to spot reliable packages, and problems can occur when connecting to obscure or old databases, so you might need more experienced software developers to find tools that can be trusted.
<br/>
Node.js’ relational database tools are not very advanced compared to its heavyweight competitors, which makes it currently unsuitable for use with server-side web applications with relational databases. Recent developments do, however, suggest that modules will soon be available to patch over this gap.
<br/><br/>
Ineffectual for HTML or CRUD projects<br/>
There are some instances in which the benefits of Node.js would prove ineffectual or pointless. When developing simple HTML or CRUD applications, where you do not need a separate API and all data comes directly from the server, Node.js provides very little benefit.
<br/>
While your application might be marginally more scalable with Node.js, you should not expect more traffic simply because you have used it. In these instances, it is reasonable to stick to web frameworks like Ruby.
<br/>
Good use cases<br/>
Node.js is very efficient with real-time applications, as it facilitates handling multiple client requests, enables sharing and reusing packages of library code, and the data sync between the client and server happens very fast. Some examples of projects that are well-suited to the use of Node.js include:
<br/>
Collaborative drawing/editing apps, where multiple people need to be able to edit and review documents and projects
Video conferencing apps that work with specific hardware of VoIP
Online gaming apps and e-commerce transaction software, where online data is important
Live chat and instant-messaging apps where instant client-server interaction is essential and constant
Minimum Viable Products, where start-ups want to validate the marketability of their product without investing too much time and money in development; if the product is well-received, it can be scaled and enhanced accordingly
Microservice architectures, popular among enterprise applications</p>
                                </div>

                            </div>

                            <div id="blog-comment">
                                <h4>Comments</h4>

                                <div className="spacer-half"></div>

                                <ol>
                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-1.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Jovan Eadie</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>

                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-2.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Ariana Haylock</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>

                                    <li>
                                        <div className="avatar">
                                            <img src="./img/blog/avatar-3.jpg" alt="blogimg"/></div>
                                        <div className="comment-info">
                                            <span className="c_name">Reginald Safi</span>
                                            <span className="c_date id-color">15 January 2020</span>
                                            <span className="c_reply"><span >Reply</span></span>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="comment">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
                                        
                                    </li>
                                </ol>

                                <div className="spacer-single"></div>

                                <div id="comment-form-wrapper">
                                    <h4>Leave a Comment</h4>
                                    <div className="comment_form_holder">
                                        <form id="contact_form" name="form1" className="form-border" method="post" action="#">
                                            <label>Name</label>
                                            <input type="text" name="name" id="name" className="form-control"/>
                                            <label>Email <span className="req">*</span></label>
                                            <input type="text" name="email" id="email" className="form-control"/>
                                            <label>Message <span className="req">*</span></label>
                                            <textarea cols="10" rows="10" name="message" id="message" className="form-control">
                                            </textarea>
                                            <p id="btnsubmit">
                                            <input type="submit" id="send" value="Send" className="btn btn-main"/>
                                            </p>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
	                </div>
	              </div>
	            </div>
	          </div>
	          )}

		</div>
	);
}

export default Blog;